/** Dietary tags a vendor can advertise. Shared by the staff directory and the vendor portal. */
export const DIETARY_OPTIONS = ["Halal", "Vegetarian", "Vegan", "Gluten-Free", "Nut-Free", "Dairy-Free", "Kosher"];

/** Palette for vendor analytics charts. Order is meaningful — keep indigo first. */
export const CHART_COLORS = ["#6366f1", "#f59e0b", "#10b981", "#ef4444", "#8b5cf6", "#ec4899"];
